<template>
  <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
    <div id="app" class="my-0 py-0">
      <v-app id="inspire">
        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
          <v-card v-model="show" class="py-0">
            <v-toolbar class="py-0 my-0" dark color="blue">
              <v-toolbar-title class="my-0 py-0">POSVENTA - Informe (EI 091)</v-toolbar-title>
              <v-spacer></v-spacer>
              Código: {{ codgral }}
              <v-spacer></v-spacer>
              <div>
                <v-btn icon @click="show = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </v-toolbar>
          </v-card>
          <v-card color="blue lighten-4" class="py-0 my-0">
            <v-card-text class="py-0 my-0">
              <v-row dense>
                <v-col cols="6" sm="4" md="4">
                  Cliente: {{ pedido.cliente }}
                </v-col>
                <v-col cols="6" sm="3" md="3">
                  Contacto: {{ pedido.contacto }}
                </v-col>
                <v-col cols="6" sm="3" md="3">
                  Mail: {{ pedido.mailcontacto }}
                </v-col>
                <v-col cols="6" sm="3" md="2">
                  Teléfono: {{ pedido.tel }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6" sm="4" md="4">
                  Referencia: {{ pedido.referencia }}
                </v-col>
                <v-col cols="6" sm="2" md="2"> Área: {{ pedido.area }} </v-col>
                <v-col cols="6" sm="3" md="3">
                  Involucra: {{ pedido.afecta }}
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  Comercial Responsable: {{ pedido.respCom }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-radio-group dense v-model="pedido.tipo" row>
                    <v-radio label="Garantía" value="Garantia" style="align-items: baseline;"></v-radio>
                    <v-radio label="Fuera de Garantía" value="fuera_garantia" style="align-items: baseline;"></v-radio>
                    <v-radio label="Mantenimiento" value="mantenimiento" style="align-items: baseline;"></v-radio>

                    <v-radio label="Asistencia Técnica / Capacitación" value="asistencia_tecnica"
                      style="align-items: baseline;"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card>
            <v-card-text>
              <v-row dense>
                <v-col cols="12" sm="12" md="12">
                  <h6>Descripción:</h6>
                  <div class="multi-line">
                    {{ pedido.archivo }}
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card color="blue lighten-5">
            <v-card-text class="py-0 my-0">
              <v-row>
                <v-col cols="6" sm="2" md="2">
                  Elaboró: {{ pedido.elaboro }}
                </v-col>
                <v-col cols="6" sm="2" md="2">
                  Fecha: {{ pedido.fecha }}
                </v-col>
                <v-col cols="6" sm="8" md="8">
                  Envió mail a: {{ pedido.mail }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="py-0 my-0">
            <v-card-text class="py-0 my-0">
              <v-row dense>
                <v-col cols="12" sm="12" md="12">
                  <h6>Ejecución:</h6>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            Detalle
                          </th>
                          <th class="text-left">
                            Responsable
                          </th>
                          <th class="text-left">
                            Fecha
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in pedido.detalle" :key="item.id">
                          <td>
                            <div class="multi-line">{{ item.descr }}</div>
                          </td>
                          <td>{{ item.resp }}</td>
                          <td>{{ item.fecha }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card color="blue lighten-5">
            <v-card-text>
              <v-row dense>
                <v-col cols="12">
                  <div class="multi-line">
                    {{ pedido.mailE }}
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card color="blue lighten-5" class="py-0 my-0">
            <v-card-text class="py-0 my-0">
              <v-row dense>
                <v-col cols="12" sm="6" md="6">
                  Referencia: {{ referencia }}

                </v-col>
                <v-col cols="6" sm="4" md="4">
                  N° de OT: {{ numot }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6" sm="4" md="4">
                  Por el Cliente: {{ clien }}
                </v-col>
                <v-col cols="6" sm="4" md="4">
                  Responsable Técnico: {{ resptec }}
                </v-col>
                <v-col cols="6" sm="4" md="4">
                  <v-select dense v-model="sector" :items="estadosector" label="Sector al que se deriva:"
                    item-text="nombre" item-value="value"></v-select>
                </v-col>
              </v-row>
              <v-row dense>
                <v-data-table dense :headers="headers" :items="listadosector" locale="es-ar" class="elevation-1"
                  :items-per-page="500" hide-default-footer></v-data-table>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="4" md="2">
                  <v-checkbox style="align-items: baseline;" v-model="pedido.cobrado" label="Cobrado" value="ON"
                    color="success"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="4" md="2" class="">
                  <v-text-field label="Fecha Cobrado:" v-model="pedido.fechaCob" readonly></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="3">
                  <v-checkbox v-model="pedido.nocobrado" label="En GARANTÍA - NO Cobrado" value="ON"
                    color="success"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="4" md="2">
                  <v-checkbox v-model="pedido.atencioncom" label="Atención Comercial" value="ON"
                    color="success"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="4" md="2">
                  <v-text-field v-model="equipo" label="Equipo"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card color="blue lighten-4" class="py-0 my-0">
            <v-card-text class="py-0 my-0">
              <v-row dense>
                <v-col cols="2" sm="2" md="2">
                  Causa Externa:
                </v-col>
                <v-col cols="10" sm="2" md="2">
                  <v-checkbox v-model="cclien" value="ON" label="Cliente" class="shrink mx-2" dense></v-checkbox>
                </v-col>
                <v-col cols="6" sm="2" md="2">
                  <v-checkbox v-model="cprov" value="ON" label="Proveedor" class="shrink mx-2" dense></v-checkbox>
                </v-col>
                <v-col cols="6" sm="6" md="4">
                  <v-select dense v-model="proveedor" :items="prove" label="Proveedor:" item-text="nombre"
                    item-value="proveedor"></v-select>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6" sm="2" md="2"> </v-col>
                <v-col cols="6" sm="4" md="4">
                  <v-checkbox v-model="ctrans" value="ON" label="Trasporte" class="shrink mx-2" dense></v-checkbox>
                </v-col>
                <v-col cols="6" sm="4" md="4">
                  <v-checkbox v-model="cotro" value="ON" label="Otras" class="shrink mx-2" dense></v-checkbox>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6" sm="2" md="1">
                  Causa Internas:
                </v-col>
                <v-col cols="6" sm="2" md="1">
                  <v-checkbox v-model="respcal" value="ON" label="SGI" dense></v-checkbox>
                </v-col>
                <v-col cols="6" sm="2" md="2">
                  <v-checkbox v-model="resping" value="ON" label="Obras y Servicios" dense></v-checkbox>
                </v-col>
                <v-col cols="6" sm="2" md="2">
                  <v-checkbox v-model="respprod" value="ON" label="Fabricación" dense></v-checkbox>
                </v-col>
                <v-col cols="6" sm="2" md="2">
                  <v-checkbox v-model="respcom" value="ON" label="Comercial" dense></v-checkbox>
                </v-col>
                <v-col cols="6" sm="2" md="2">
                  <v-checkbox v-model="respabas" value="ON" label="Abastecimiento" dense></v-checkbox>
                </v-col>
                <v-col cols="6" sm="2" md="1">
                  <v-checkbox v-model="respdep" value="ON" label="Depósito" dense></v-checkbox>
                </v-col>
                <v-col cols="6" sm="2" md="1">
                  <v-checkbox v-model="respvar" value="ON" label="Varios" dense></v-checkbox>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6" sm="2" md="2">
                  Afecta:
                </v-col>
                <v-col cols="6" sm="2" md="2">
                  <v-checkbox v-model="afeccal" value="ON" label="Calidad"></v-checkbox>
                </v-col>
                <v-col cols="6" sm="2" md="2">
                  <v-checkbox v-model="afecma" value="ON" label="Medio Ambiente"></v-checkbox>
                </v-col>
                <v-col cols="6" sm="2" md="2">
                  <v-checkbox v-model="afecsyso" value="ON" label="SST"></v-checkbox>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6" sm="4" md="4">
                  Notificar al Cliente?
                  <!-- </v-col>
                  <v-col sm="4" md="4"> -->
                  <v-radio-group dense v-model="notificar" row>
                    <v-radio label="SI" value="SI" style="align-items: baseline;"></v-radio>
                    <v-radio label="NO" value="NO" style="align-items: baseline;"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="6" sm="8" md="8">
                  No Conformidad
                  <!-- </v-col>
                  <v-col sm="4" md="4"> -->
                  <v-radio-group dense v-model="noConformidad" row>
                    <v-radio label="SI" value="SI" style="align-items: baseline;"></v-radio>
                    N°:
                    <v-text-field v-model="numNoconformidad" dense class="shrink mx-2" maxlength="10">
                    </v-text-field>
                    <v-radio label="NO" value="NO" style="align-items: baseline;"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field label="Días a ser considerados en indicador" v-model="indic"
                    maxlength="10"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field label="Año" v-model="anioindic" maxlength="4"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field label="Motivo de demora" v-model="motivoindicador"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field label="N° de Acta" v-model="acta" maxlength="4"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-select v-model="estado" :items="itemestado" label="Estado" item-text="nombre"
                    item-value="value"></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field label="Fecha Cierre" v-model="fechacierre" maxlength="10"></v-text-field>
                </v-col>
              </v-row>

              <v-row dense> </v-row>
            </v-card-text>
          </v-card>
          <v-card v-if="fileInfos.length > 0" class="mx-auto">
            <v-list>
              <v-subheader>Lista de archivos</v-subheader>
              <v-list-item-group color="primary">
                <v-list-item v-for="(file, index) in fileInfos" :key="index">
                  <v-list-item-content>
                    <v-list-item-title class="mb-3">
                      <a target="_blank" :href="'https://api.icssa.com.ar/informes/' + file.descripcion
                        ">{{ file.titulo }}</a>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>

          <v-card color="blue" dark tile>
            <v-card-actions>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-app>
    </div>
  </v-dialog>
</template>
<style scoped>
.multi-line {
  white-space: pre-line;
}
</style>
<script>
import moment from "moment";
import { SelectingTimes } from "vuetify/lib/components/VTimePicker/VTimePicker";
import axios from "../../../../src/axios-auth";
export default {
  data: (vm) => ({
    usuario: "",
    valid: false,
    validsubir: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    pedido: [],
    proveedor: "",
    prove: [],
    elaboro: "",
    descrip: "",
    direcciones: [],
    direccion: "",
    correos: "",
    destinatarios: [],
    mail: [{ address: "" }],
    fecha: moment().format("DD/MM/YYYY"),
    clien: "",
    resptec: "",
    numot: "",
    referencia: "",
    cobrado: "",
    nocobrado: "",
    atencioncom: "",
    fechacob: "",
    equipo: "",
    cclien: "",
    cprov: "",
    ctrans: "",
    cotro: "",
    respcal: "",
    resping: "",
    respprod: "",
    respcom: "",
    respabas: "",
    respdep: "",
    respvar: "",
    afeccal: "",
    afecma: "",
    afecsyso: "",
    acta: "",
    notificar: "",
    noConformidad: "",
    numNoconformidad: "",
    indic: "",
    motivoindicador: "",
    anioindic: "",
    fechacierre: "",
    estado: "",
    fileInfos: [],
    sector: { nombre: "", value: "" },
    estadosector: [
      { nombre: "Comercial", value: "CO" },
      { nombre: "Ingeniería de Obra", value: "IO" },
      { nombre: "Ingeniería de Producto", value: "IP" },
      { nombre: "Fabricación", value: "FA" },
      { nombre: "Abastecimiento", value: "AB" },
      { nombre: "Proveedor", value: "PR" },
      { nombre: "Cliente", value: "CL" },
      { nombre: "Depósito", value: "DE" },
      { nombre: "Inspección y Ensayos", value: "CA" },
      { nombre: "Administración", value: "AD" },
    ],
    itemestado: [
      { nombre: "Pendiente", value: "Pendiente" },
      { nombre: "Cerrado", value: "Cerrado" },
    ],
    message: "",
    headers: [{
      text: "Sector",
      align: "start",
      sortable: false,
      value: "sector",
    },
    { text: "Fecha", value: "fecha", sortable: false },
    ],
    listadosector: [],
    visible: true,
    codgral: "",
  }),

  // props: ["visible", "codgral"],
  computed: {
    show: {
      get() {
        //this.mostrar = true;
        //   this.elaboro = this.$store.state.nombre.toString().trim();

        //   this.cargarPedido();
        //   this.cargarAnalisis();

        return this.visible;
      },
      set(value) {
        if (!value) {
          this.vaciarListado();
          this.$refs.form.resetValidation();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    vaciarModels() {
      this.pedido = [];
    },
    cargarProve() {
      let self = this;
      axios
        .get("/Obras/GetProve?")
        .then((response) => {
          self.prove = response.data;
        })
        .catch((error) => {
          self.prove = [];
          console.log(error);
        });
    },

    cargarAnalisis() {
      const codigo = this.codgral;
      let self = this;
      axios
        .get("/App/CargarAnalisis?", {
          params: {
            codigo: codigo,
          },
        })
        .then((response) => {
          self.cclien = response.data.cclien;
          self.cprov = response.data.cprov;
          self.proveedor = response.data.proveedor;
          self.ctrans = response.data.ctrans;
          self.cotro = response.data.cotro;
          self.respcal = response.data.respcal;
          self.resping = response.data.resping;
          self.respprod = response.data.respprod;
          self.respcom = response.data.respcom;
          self.respabas = response.data.respabas;
          self.respdep = response.data.respdep;
          self.respvar = response.data.respvar;
          self.afeccal = response.data.afeccal;
          self.afecma = response.data.afecma;
          self.afecsyso = response.data.afecsyso;
          self.notificar = response.data.notificar;
          self.noConformidad = response.data.noConformidad;
          self.numNoconformidad = response.data.numNoconformidad;
          self.indic = response.data.indic;
          self.anioindic = response.data.anioindic;
          self.motivoindicador = response.data.motivoindicador;
          self.acta = response.data.acta;
          self.estado = response.data.estado;
          self.fechacierre = response.data.fechacierre;
        })
        .catch((error) => {
          //self.nomcodigo = [];
          console.log(error);
        });
    },
    cargarPedido() {
      const codigo = this.codgral;
      let self = this;
      axios
        .get("/App/CargarEjecucion?", {
          params: {
            codigo: codigo,
          },
        })
        .then((response) => {
          self.pedido = response.data;
          self.id = response.data.id;
          self.idpedido = response.data.idpedido;
          self.referencia = response.data.referencia;
          self.numot = response.data.numot;
          self.numnp = response.data.oc;
          self.resptec = response.data.respTec;
          self.clien = response.data.clien;
          self.sector = response.data.estadoSector;
          self.fileInfos = response.data.informes;
          self.cobrado = response.data.cobrado;
          self.fechacob = response.data.fechaCob;
          self.nocobrado = response.data.nocobrado;
          self.atencioncom = response.data.atencioncom;
          // self.equipoMarca = response.data.equipomarca;
          // self.equipoModelo = response.data.equipomodelo;
          self.equipo = response.data.equipoModelo;
          self.listadosector = response.data.tiemposector;
        })
        .catch((error) => {
          self.nomcodigo = [];
          console.log(error);
        });
    },

    vaciarListado() { },
  },
  beforeMount() {
    this.codgral = this.$route.query.codgral;
    this.cargarPedido();
    this.cargarAnalisis();

    return this.visible;
  },
};
</script>
